module.exports = __webpack_public_path__ + "img/help.5c3d86be.svg";